
export function convertirMenuHorizontalAVertical(navMenuItemsHorizontal) {
  const resultado = []

  navMenuItemsHorizontal.forEach(grupo => {
    // Si tiene hijos (children)
    if (Array.isArray(grupo.children) && grupo.children.length) {
      const seccion = grupo.header || 'Sección'

      resultado.push({
        header: seccion,
        icon: grupo.icon || 'fa-solid fa-folder',
        key: `header-${seccion}`,
      })

      grupo.children.forEach(item => {
        resultado.push({
          title: item.title,
          route: item.route,
          icon: item.icon,
          key: `${seccion}-${item.route || ''}-${item.title}`,
        })
      })
    }
  })

  return resultado
}
